<template>
    <div class="my-10">
        <h1 class="mb-7 text-xl">{{ $t('page.searchResults') }}: <span class="font-semibold">{{ this.searchQuery }}</span></h1>
        <div class="grid grid-cols-4 gap-4 max-lg:grid-cols-3 max-md:grid-cols-2">

            <template v-if="products.length > 0">
                <router-link v-for="item in products" :key="item?.id"
                    :to="{ name: 'foodRestaurantProductDetail', params: { id: item?.id } }">
                    <FoodCard @likeAction="likeAction" :detail="item">
                    </FoodCard>
                </router-link>
            </template>
            <div v-show="products.length === 0 && loading === false">
                <p class="text-xl font-medium whitespace-nowrap">{{ $t('page.not_found') }}</p>
            </div>

        </div>
        <div v-show="loading === true" class="flex justify-center mt-10" role="status">
            <IconSpinner class="w-12 h-12 mr-2 text-gray-200 animate-spin  fill-main-color">
            </IconSpinner>

            <span class="sr-only">Loading...</span>
        </div>
    </div>

</template>

<script>
import IconSpinner from '@icons/IconSpinner.vue';
import FoodCard from '@cmp/food/FoodCard.vue'
import api from '@/api';
export default {
    name: 'foodSearch',
    components: {
        FoodCard,
        IconSpinner
    },
    watch: {
        '$route.query.searchQuery': {
            //   immediate: true,
            async handler(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.searchQuery = newValue
                    this.products = []
                    await this.getProducts()
                }

            },
        },
    },
    data() {
        return {
            loading: false,
            products: [],
            searchQuery: null,
            page: 1,
            count: 0,
            next: null
        }
    },
    methods: {
        infiniteScroll() {
            let scrollTop = document.documentElement.scrollTop
            let scrollHeight = document.documentElement.scrollHeight
            let clientHeight = document.documentElement.clientHeight
            if (scrollTop + clientHeight >= scrollHeight - 650) {
                if (this.next !== null && this.loading === false) {
                    this.page += 1
                    this.getProducts()
                }
            }
        },
        async getProducts() {
            this.loading = true
            try {
                const response = await api.get('exhibition/products/', { params: { search: this.searchQuery, page: this.page, location: this.getLocation.id } })
                const results = response.data.results
                results.forEach(element => {
                    this.products.push(element)
                });
                this.count = response.data.count
                this.next = response.data.next
            } catch (e) {
                console.log(e)
            }
            this.loading = false
        },
        async likeAction(id, like) {
            if (this.$store.authStatus === false) {
                this.$store.setState('loginModal', true)
                return
            }
            try {
                const response = await api.post(`exhibition/products/${id}/like/`, { is_liked: like });
                this.$store.getLiked('exhibition')
            } catch (e) {
                console.log(e)
            }
        },
        
    },
    computed: {
        getLocation(){
            return JSON.parse(localStorage.getItem('selectedLocation')) || 1
        }
    },
    mounted() {
        window.addEventListener("scroll", this.infiniteScroll)
    },
    unmounted() {
        window.removeEventListener("scroll", this.infiniteScroll)
    },
    async created() {
        this.searchQuery = this.$route.query.searchQuery
        await this.getProducts()

    }
}

</script>

<style scoped></style>
